import { useState, useEffect, useRef } from "react";
import { styled, keyframes } from "styled-components";
import univLogo from "../../../images/resource/images/충남대로고.png";
import vetInfo from "../../../config/vetInfo";
// import profileImg from "../../../images/vet/백성현.png";
let profileImg;
try {
  profileImg = require("../../../images/vet/황야원.png");
} catch (e) {
  profileImg = null;
}
function Introduce() {
  const [animate, setAnimate] = useState(false);

  const [windowWidth, setWindowWidth] = useState();
  const componentRef = useRef(null);

  const moonInfo = vetInfo.filter((i) => i.id === 3)[0];

  useEffect(() => {
    setWindowWidth(window.innerWidth);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      // 예시: 화면의 중간에 도달했을 때 애니메이션을 실행하려면
      // const midScreen = window.innerHeight / 100;
      const componentTop = componentRef.current.getBoundingClientRect().top;

      if (componentTop < window.innerHeight) {
        setAnimate(true);
      }
      // else {
      //   setAnimate(false);
      // }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      // 컴포넌트 언마운트 시 이벤트 리스너 제거
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <IntroduceContainer ref={componentRef} id={"Main_Intro"}>
      {windowWidth > 900 ? (
        <ImageWrapper style={{ right: "5vh" }}>
          <img
            style={{ maxHeight: "760px", width: "620px" }}
            className={animate ? "animate" : ""}
            src={profileImg}
            alt="profile img"
          />
        </ImageWrapper>
      ) : (
        <></>
        // <MobileImg
        //   src={profileImg}
        //   alt="profile img"
        //   style={{
        //     width: "10rem",
        //     position: "absolute",
        //     right: 0,
        //     top: 35,
        //     zIndex: 0,
        //   }}
        // />
      )}
      <TextWrapper style={{ zIndex: 1 }}>
        <div className={animate ? "titleWrapper animate" : "titleWrapper"}>
          <h2>안녕하세요.</h2>
          <h2>
            <strong>
              부평SKY동물메디컬센터
              <br /> 대표원장 황야원입니다.
            </strong>
          </h2>
        </div>
        <div className={animate ? "contentWrapper animate" : "contentWrapper"}>
          <p style={{ whiteSpace: "pre-wrap", maxWidth: "600px" }}>
            {`부평SKY동물의료센터를 찾아 주셔서 감사합니다.

2017년 개원한 저희 부평SKY동물의료센터는 24시간 언제든지 소중한 반려동물의 건강을 지키기 위해 최선을 다하고 있습니다.

전문적인 의료진과 최신 장비를 갖추고 과별 진료를 통해 정확한 진단과 치료를 진행하고 있습니다.

언제나 보호자님과 반려동물의 건강과 행복을 최우선으로 생각하며, 믿고 맡길 수 있는 부평SKY동물의료센터로서 함께 하겠습니다.
감사합니다.
`}
            <p>
              <strong>대표원장 황야원 올림.</strong>
            </p>
            {/* 24시간 연중무휴로 공휴일, 명절 없이 한밤중이라도 걱정없이
            {windowWidth > 800 ? <br /> : ", "}
            진료받을 수 있도록 하는 진료시스템을 마련하고 있습니다. */}
          </p>
          {/* 원장 인사말에 약력 넣을건지 확인 필요 */}
          {/* <ul>
            {moonInfo?.history?.map((item) => {
              return <li>{item}</li>;
            })}
          </ul> */}
        </div>
      </TextWrapper>
    </IntroduceContainer>
  );
}

const slideRight = keyframes`
    from {
        transform: translate(30%, 0);
        opacity: 0;
    }
    to {
        transform: translate(0,0);
        opacity: 1;
    }
`;

const slideLeft = keyframes`
    from {
        transform: translate(-30%, 0);
        opacity: 0;
    }
    to {
        transform: translate(0, 0);
        opacity: 1;
    }
`;

const IntroduceContainer = styled.section`
  width: 100%;
  height: fit-content;
  padding-top: 10vh;
  position: relative;
  display: flex;
  justify-content: space-between;
  /* background: url(${univLogo}) center no-repeat; */
  background-size: 40%;

  @media screen and (max-width: 900px) {
    /* background-size: 90%; */
    padding-top: 1rem;
    align-items: center;
  }

  * {
    margin: 0;
  }
`;

const TextWrapper = styled.div`
  padding: 10vh 12vw;
  animation-play-state: paused;
  animation: ${slideLeft} 4s ease;

  /* .animate {
    animation: ${slideLeft} 4s ease;
  } */

  .titleWrapper {
    h2 {
      font-size: 2rem;
      font-weight: normal;

      @media screen and (max-width: 690px) {
        font-size: 1.5rem;
      }
    }
  }
  .contentWrapper {
    p {
      margin: 35px 0;

      @media screen and (max-width: 690px) {
        font-size: 0.9rem;
      }
    }
    ul {
      li {
        list-style-type: none;
        position: relative;
        right: 35px;
        margin-bottom: 10px;

        @media screen and (max-width: 690px) {
          font-size: 0.9rem;
        }

        &:before {
          content: "";
          display: inline-block;
          width: 3px;
          height: 9px;
          background: #3d81b8;
          transform: rotate(45deg);
          margin-right: 10px;
          vertical-align: super;
        }
      }
    }
  }
`;

const ImageWrapper = styled.div`
  width: 45%;
  height: 100%;
  position: absolute;
  right: 10vw;
  bottom: 0;
  display: flex;
  align-items: flex-end;
  /* animation-play-state: paused;
  animation: ${slideRight} 4s ease; */

  .animate {
    animation: ${slideRight} 4s ease;
  }

  .animate_10 {
    animation: ${slideRight} 10s ease;
  }

  @media screen and (max-width: 900px) {
    display: none;
  }

  img {
    width: 100%;
    height: auto;
  }
`;

const MobileImageWrapper = styled.div`
  width: 45%;
  height: 100%;
  position: absolute;
  right: 10vw;
  bottom: 0;
  display: flex;
  align-items: flex-end;

  .animate {
    animation: ${slideRight} 4s ease;
  }

  .animate_10 {
    animation: ${slideRight} 10s ease;
  }

  @media screen and (max-width: 690px) {
    display: none;
  }

  img {
    width: 100%;
    height: auto;
  }
`;

const MobileImg = styled.img`
  animation: ${slideRight} 7s ease;
`;

export default Introduce;
